import { ReactComponent as JiraIcon } from 'assets/icons/logos/jira.svg'
import cx from 'classnames'
import { FormatBar } from 'common/Prose/components/FormatBar/FormatBar'
import { StrongNode, nodes } from 'prose-core'
import { forwardRef, useRef } from 'react'
import { useReactNodeView } from '../ReactNodeView/ReactNodeViewContext'
import Styles from './JiraEmbed.module.scss'
import { JiraIssue } from './JiraIssue'

export const JiraEmbed = forwardRef<HTMLDivElement, {}>((_render, _contentDomRef) => {
  const context = useReactNodeView()
  const { node } = context
  const isSelected = context.isSelected ?? false
  const selfRef = useRef<HTMLDivElement>(null)

  return (
    <div className={cx(Styles.jiraEmbed, { [Styles.isSelected]: isSelected })} ref={selfRef}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
      {isSelected && <FormatBar icon={JiraIcon} title="Jira Embed" mode={node!.attrs.mode} url={node!.attrs.link} />}
      <JiraIssue node={node as StrongNode<typeof nodes.jira_embed>} />
    </div>
  )
})
